import React, { useRef } from "react";

import { capitalizeAndJoin, searchUsers } from "utils";

import { ExpandOption } from "../ExpandOption/ExpandOption";
import { PersonSearchOption } from "../PersonSearchOption/PersonSearchOption";
import { toggle } from "../utils/personSearch";

const defaultSearchOptions = {
	searchParameters: [ { key: "userAccountId", operator: "^" } ],
	keyParamName: "userAccountId",
};

const usePersonSearch = () => {
	const expandRef = useRef(null);

	const expandOption = {
		key: "expand",
		value: "expand",
		content: <ExpandOption expandRef={expandRef} />,
	};

	const onExpandClicked = () => {
		const allExpanded = [ ...document.getElementsByClassName("person-search-toggle-icon") ]
			.every(icon => icon.getAttribute("data-icon") === "chevron-down");

		if (allExpanded) {
			toggle(expandRef.current, true);
		} else {
			toggle(expandRef.current, false);
		}
	};

	const search = (searchText, params = {}) => {
		const options = {
			keyParamName: "personId",
			searchParameters: [],
		};

		const searchOptions = { ...defaultSearchOptions, ...options, ...params };

		return searchUsers(searchText, searchOptions).then(response => {
			const options = (response.content ?? []).map(person => {
				const primaryAssociation = (person.affiliations ?? []).find(
					affiliation => affiliation.primaryAppointment
				);

				return {
					key: person[searchOptions.keyParamName],
					value: person[searchOptions.keyParamName],
					text: person.fullName,
					person: {
						...person,
					},
					content: (
						<PersonSearchOption
							option={{
								id: person.personId,
								name: person.fullName,
								email: person.contactEmail,
								title: primaryAssociation?.unitName,
								profileTypes: capitalizeAndJoin(person.profileTypes),
							}}
							expandRef={expandRef}
							onExpandClicked={onExpandClicked}
						></PersonSearchOption>
					),
				};
			});

			if(options.length > 0) {
				options.unshift(expandOption);
			}

			return {
				options,
				hiddenOptionsCount:
                    response.totalPages > 1 &&
                    response.totalElements - response.content.length,
			};
		});
	};

	return { search };
};

export default usePersonSearch;
